<template>
    <div class="user-info">
        <base-divider text="基本信息"/>

        <!--基本信息-->
        <el-row :gutter="100" class="form">
            <el-form :model="dataForm" ref="form" label-width="80px" :disabled="disabled">
                <el-col :span="8">
                    <el-form-item label="姓名">
                        <el-input v-model="dataForm.name" ></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="8">
                    <el-form-item label="会员等级">
                        <el-input :value="dataForm.userLevel" readonly ></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="8">
                    <el-form-item label="会员编号">
                        <el-input :value="dataForm.serialNo"  readonly></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="8">
                    <el-form-item label="缴费年限">
                        <el-input :value="dataForm.payYears" readonly ></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="8">
                    <el-form-item label="到期时间">
                        <el-input :value="dataForm.validDate" readonly ></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="8">
                    <el-form-item label="申请时间">
                        <el-input :value="dataForm.updateDate" readonly ></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="8">
                    <el-form-item label="状态">
                        <el-input :value="dataForm.accountStatus ? '禁用' : '正常'" readonly></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="8">
                    <el-form-item label="入会时间">
                        <el-input :value="dataForm.inTeamTime" readonly></el-input>
                    </el-form-item>
                </el-col>

                <!-- 政治面貌 -->
                <el-col :span="8">
                    <el-form-item label="政治面貌" prop="politicsStatus">
                        <el-select v-model="dataForm.politicsStatus">
                            <el-option
                                    v-for="department in politicsStatusList"
                                    :key="department.id"
                                    :label="department.remark"
                                    :value="department.remark"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="8">
                    <el-form-item label="邮箱">
                        <el-input :value="dataForm.email" ></el-input>
                    </el-form-item>
                </el-col>

                <!-- 性别 -->
                <el-col :span="8">
                    <el-form-item label="性别" prop="gender">
                        <el-select v-model="dataForm.gender">
                            <el-option key="0" label="男" :value="0"></el-option>
                            <el-option key="1" label="女" :value="1"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="8">
                    <el-form-item label="出生年月">
                        <el-date-picker
                                v-model="dataForm.birthday"
                                :editable="false"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                type="date"
                                placeholder="选择日期"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-col>

                <!-- 工作地区 -->
                <el-col :span="8">
                    <el-form-item label="工作地区" prop="address">
                        <el-cascader
                                ref="address"
                                v-model="dataForm.address"
                                :options="city"
                                popper-class="custom-address"
                                @change="handleChangeCity">
                        </el-cascader>
                    </el-form-item>
                </el-col>

                <el-col :span="8">
                    <el-form-item label="手机号码">
                        <el-input v-model="dataForm.phone" ></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="8">
                    <el-form-item label="医院">
                        <el-input v-model="dataForm.hospitalName" ></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="8">
                    <el-form-item label="机构">
                        <el-select v-model="dataForm.orgId" @change="handleChangeOrg" ref="org">
                            <el-option
                                    v-for="org in orgList"
                                    :key="org.id"
                                    :label="org.nameCh"
                                    :value="org.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="8">
                    <el-form-item label="科室">
                        <el-input v-model="dataForm.department" ></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="8">
                    <el-form-item label="级别职称">
                        <el-select v-model="dataForm.titile">
                            <el-option
                                    v-for="department in titleList"
                                    :key="department.id"
                                    :label="department.remark"
                                    :value="department.remark"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-col :span="24">
                <!--操作按钮-->
                <div center>
                    <el-button
                            @click="disabled = false"
                            type="primary"
                            v-if="disabled"
                            icon="el-icon-edit">编辑</el-button>
                    <div v-else>
                        <el-button
                                @click="disabled = true"
                                icon="el-icon-edit">取消</el-button>
                        <el-button
                                @click="submitForm('form')"
                                :loading="submitLoading"
                                type="primary"
                                icon="el-icon-check"
                        >保存</el-button>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex'
    import BaseDivider from '@/components/BaseDivider/BaseDivider'
    import city from '@/assets/json/cityDict.json'
    import {getOrgListByName, getDictType, getUserLevel, perfectInformation} from '@/http/request'

    export default {
        name: 'userInfo',
        components: {BaseDivider},
        data() {
            const dataForm = JSON.parse(JSON.stringify(this.$store.state.userInfo));
            dataForm.address = [dataForm.provinceId, dataForm.cityId, dataForm.areaId]
            return {
                userLevelList: [], // 会员等级列表
                orgList: [], // 机构列表
                departmentList: [], // 科室列表
                vocationalTypeList: [], // 职业类型
                titleList: [], // 职称列表
                politicsStatusList: [], // 政治面貌列表
                city: city.data, // 城市字典
                disabled: true, // 默认为true，当编辑时为false
                submitLoading: false, // 提交loading
                dataForm
            }
        },
        computed: {
            ...mapState({
                userInfo: state => state.userInfo
            })
        },
        created() {
            this.initData();
        },
        methods: {
            ...mapActions(['setUserInfo']),

            // 初始化页面数据
            initData() {
                const loading = this.$loading({
                    lock: true,
                    text: '加载中',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                Promise.all([
                    this.getOrgListByName(),
                    this.getDepartment(),
                    this.getVocationalTypeList(),
                    this.getTitleList(),
                    this.getPoliticsStatusList()
                ]).then(data => {
                    setTimeout(() => {
                        loading.close();
                    }, 1000)

                    // 判断所有接口返回的状态码是不是正常
                    if (data.some(res => res.data.code !== 0)) {
                        loading.text = '数据加载失败'
                        setTimeout(() => {
                            loading.close();
                        }, 2000)
                        return
                    }

                    this.orgList = data[0].data.data; // 机构
                    this.departmentList = data[1].data.data; // 科室
                    this.vocationalTypeList = data[2].data.data; // 职业类型
                    this.titleList = data[3].data.data; // 职称列表
                    this.politicsStatusList = data[4].data.data; // 政治面貌列表
                }).catch(() => {
                    loading.text = '数据加载失败'
                    setTimeout(() => {
                        loading.close();
                    }, 1500)
                })
            },

            // 获取机构列表
            getOrgListByName() {
                return getOrgListByName()
            },

            // 获取科室
            getDepartment() {
                return getDictType({dictType: 'department'})
            },

            // 获取职业类型
            getVocationalTypeList() {
                return getDictType({dictType: 'vocationalType'})
            },

            // 获取职业类型
            getTitleList() {
                return getDictType({dictType: 'title'})
            },

            // 获取政治面貌
            getPoliticsStatusList() {
                return getDictType({dictType: 'politics_status'})
            },

            // 获取会员等级列表
            getUserLevel() {
                getUserLevel().then(({data}) => {
                    if (data.code === 0) {
                        this.userLevelList = data.data
                    } else {
                        this.$message({
                            type: 'error',
                            message: data.msg
                        })
                    }
                })
            },

            // 选择机构
            handleChangeOrg(res) {
                this.orgList.map(o => {
                    if (o.id === res) {
                        this.$set(this.dataForm, 'orgName', o.nameCh)
                    }
                })
            },

            // 选择城市
            handleChangeCity(data) {
                const res = this.$refs['address'].getCheckedNodes()[0].pathLabels;
                this.$set(this.dataForm, 'province', res[0])
                this.$set(this.dataForm, 'provinceId', data[0])
                this.$set(this.dataForm, 'city', res[1])
                this.$set(this.dataForm, 'cityId', data[1])
                this.$set(this.dataForm, 'area', res[2])
                this.$set(this.dataForm, 'areaId', data[2])
            },

            // 提交
            submitForm(formName) {
                const that = this;
                // 校验学生证是否上传
                // if (this.isStudent) {
                //     this.$refs['uploadFormData'].validateField('uploadImg');
                // }

                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        that.submitLoading = true;
                        perfectInformation({...this.dataForm, id: this.userInfo.id}).then(({data}) => {
                            that.submitLoading = false;
                            if (data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: '操作成功',
                                    duration: 500,
                                    onClose() {
                                        that.setUserInfo(data.data);
                                        that.disabled = true;
                                    }
                                })
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: data.msg
                                })
                            }
                        })
                    } else {
                        return false
                    }
                })
            },
        }
    }
</script>

<style lang="less" scoped>
    .user-info {
        overflow: hidden;
        .form {
            margin-top: 50px;
        }
        .el-date-editor.el-input, .el-select, .el-cascader {
            width: 100%;
        }
    }
</style>